import { Link } from 'react-router-dom';
import { DotLoading } from 'antd-mobile';
import { useEffect } from 'react';
import './home.scss';
import carServiceBookingSvg from '../../assets/car-service-booking.svg';
import matainRecordSvg from '../../assets/matain-record.svg';
import recallNoticeSvg from '../../assets/recall-notice.svg';
import insuranceInfoSvg from '../../assets/insurance-info.svg';
import prepaidRecordSvg from '../../assets/prepaid-record.svg';
import carBindingSvg from '../../assets/car-binding.svg';
import statusFailSvg from '../../assets/status-fail.svg';
import statusReminderSvg from '../../assets/status-reminder.svg';
import successSvg from '../../assets/success.svg';

const menuList = [
  {
    to: '/car-service-booking',
    icon: carServiceBookingSvg,
    label: '愛車預約保養 CarServiceBooking',
  },
  {
    to: '/maintenance-record',
    icon: matainRecordSvg,
    label: '保修記錄 MaintenanceRecord',
  },
  {
    to: '/recall',
    icon: recallNoticeSvg,
    label: '召修公告 RecallNotice',
  },
  
  {
    to: '/insurance-info',
    icon: insuranceInfoSvg,
    label: '保險資訊 InsuranceInfo',
  },
  {
    to: '/prepaid-record',
    icon: prepaidRecordSvg,
    label: '預付商品使用紀錄 PrepaidRecord',
  },
  {
    to: '/binding-car',
    icon: carBindingSvg,
    label: '綁定車輛 BindingCar',
  },
  {
    to: '/binding-fail',
    icon: statusFailSvg,
    label: '綁定失敗 BindingFail',
  },
  {
    to: '/binding-warm',
    icon: statusReminderSvg,
    label: '提醒 BindingWarn',
  },
  {
    to: '/binding-success',
    icon: successSvg,
    label: '綁定成功 BindingSuccess',
  },
  {
    to: '/loading',
    icon: <DotLoading color="#EB0A1E" style={{ fontSize: 48 }} />,
    label: '系統執行中 Loading',
  },
];

export default function Home() {
  useEffect(() => {
    // 確保頁面加載時滾動到頂部
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="home-page-wrapper">
      <div className="home-container">
        <h2 className="home-title">目錄</h2>
        <div className="home-menu-grid">
          {menuList.map(menu => (
            <Link to={menu.to} className="home-menu-card" key={menu.to}>
              {typeof menu.icon === 'string' ? (
                <img src={menu.icon} alt={menu.label} className="home-menu-card-icon" />
              ) : (
                <span className="home-menu-card-icon">{menu.icon}</span>
              )}
              <div className="home-menu-card-label">
                {menu.label.split(/([\u4e00-\u9fa5]+)([A-Za-z0-9\s]+)/).filter(Boolean).map((part, idx) => (
                  <div key={idx}>{part.trim()}</div>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
  